export function getViewerAssetsPath(): string {
  const cloudfrontEndpoint = import.meta.env.VITE_CLOUDFRONT_ENDPOINT
  return cloudfrontEndpoint
    ? `${cloudfrontEndpoint}/viewer-assets`
    : '/viewer-assets'
}
